import {
  DEFAULT_SEO_DESCRIPTION,
  DEFAULT_SEO_KEYWORDS,
  DEFAULT_SEO_TITLE,
  DEFAULT_ROBOTS,
  FB_APP_ID,
} from "./seo";

export type StaticSeoEntry = {
  title: string;
  description: string;
  /** Optional OG title; falls back to title when omitted */
  ogTitle?: string;
  /** Optional OG description; falls back to description when omitted */
  ogDescription?: string;
  keywords: string;
  path: string;
  ogType?: string;
  robots?: string;
  // Optional relative/absolute image URL for OG/Twitter
  image?: string;
  ogImageType?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  siteName?: string;
  locale?: string;
  localeAlternate?: string;
  articlePublisher?: string;
  author?: string;
  publisher?: string;
  themeColor?: string;
  htmlLang?: string;
  twitterSite?: string;
  twitterCreator?: string;
  alternates?: Array<{ hrefLang: string; href: string }>;
  iconHref?: string;
  appleTouchIconHref?: string;
  jsonLd?: any;
  /** Facebook / Meta App ID for Sharing Debugger (fb:app_id) */
  fbAppId?: string;
};

export const staticSeoByPath: Record<string, StaticSeoEntry> = {
  "/": {
    title: "Bhagavad Gita, Ramayan & Hindu Spiritual Books Online | Gita Seva",
    description:
      "Read Bhagavad Gita, Ramayan, Mahabharat, Puran, Stotra, Aarti, Pravachan & Hindu spiritual books in हिन्दी, Sanskrit & English online. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/" },
      { hrefLang: "en", href: "https://gitaseva.org/" },
      { hrefLang: "x-default", href: "https://gitaseva.org/" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Gita Seva",
      url: "https://gitaseva.org",
      logo: "https://gitaseva.org/logo512.png",
      image: "https://gitaseva.org/logo512.png",
      description:
        "Read Bhagavad Gita, Ramayan, Mahabharat, Puran, Stotra, Aarti, Pravachan & Hindu spiritual books in हिन्दी, Sanskrit & English online. Available on Gita Seva web & mobile app.",
      sameAs: [
        "https://www.facebook.com/gitaseva",
        "https://www.instagram.com/gitaseva",
        "https://www.youtube.com/@gitaseva",
      ],
      foundingDate: "2017",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
      },
    },
  },
  "/about": {
    title: "गीता सेवा ट्रस्ट | उद्देश्य, आध्यात्मिक मार्गदर्शन एवं सेवा कार्य | Gita Seva",
    description:
      "गीता सेवा ट्रस्ट का उद्देश्य भगवत्प्राप्ति के सहज मार्ग, गीता एवं संत-महात्माओं के आध्यात्मिक संदेशों का प्रचार और आधुनिक माध्यमों से उच्च मानव-मूल्यों को विश्वभर में स्थापित करना है। Available on Gita Seva web & mobile app.",
    ogTitle: "गीता सेवा ट्रस्ट | उद्देश्य, आध्यात्मिक मार्गदर्शन एवं सेवा कार्य | Gita Seva",
    ogDescription:
      "गीता सेवा ट्रस्ट के उद्देश्य, भगवत्प्राप्ति के सहज मार्ग, गीता प्रचार, संत-महात्माओं के प्रवचनों और उच्च मानव-मूल्यों के प्रसार के बारे में जानें। Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/about",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/about" },
      { hrefLang: "en", href: "https://gitaseva.org/about" },
      { hrefLang: "x-default", href: "https://gitaseva.org/about" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "गीता सेवा ट्रस्ट | उद्देश्य, आध्यात्मिक मार्गदर्शन एवं सेवा कार्य | Gita Seva",
      url: "https://gitaseva.org/about",
      isPartOf: {
        "@type": "WebSite",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
      description:
        "गीता सेवा ट्रस्ट का उद्देश्य भगवत्प्राप्ति के सहज मार्ग, गीता एवं संत-महात्माओं के आध्यात्मिक संदेशों का प्रचार और आधुनिक माध्यमों से उच्च मानव-मूल्यों को विश्वभर में स्थापित करना है। Available on Gita Seva web & mobile app.",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
    },
  },
  "/privacypolicy": {
    fbAppId: FB_APP_ID,
    title: "गोपनीयता नीति | Privacy Policy | Gita Seva",
    description:
      "गीता सेवा की गोपनीयता नीति पढ़ें। जानें कि हम आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित रखते हैं। Gita Seva Privacy Policy. Available on Gita Seva web & mobile app.",
    ogTitle: "गोपनीयता नीति | Privacy Policy | Gita Seva",
    ogDescription:
      "गीता सेवा की गोपनीयता नीति — आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित रखी जाती है। Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/privacypolicy",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/privacypolicy" },
      { hrefLang: "en", href: "https://gitaseva.org/privacypolicy" },
      { hrefLang: "x-default", href: "https://gitaseva.org/privacypolicy" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "गोपनीयता नीति | Privacy Policy | Gita Seva",
      url: "https://gitaseva.org/privacypolicy",
      isPartOf: {
        "@type": "WebSite",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
      description:
        "गीता सेवा की गोपनीयता नीति पढ़ें। जानें कि हम आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित रखते हैं। Gita Seva Privacy Policy. Available on Gita Seva web & mobile app.",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
    },
  },
  "/termsofuse": {
    title: "उपयोग की शर्तें | Terms of Use | Gita Seva",
    description:
      "गीता सेवा वेबसाइट और ऐप के उपयोग की शर्तें पढ़ें। सेवा का उपयोग करने से पहले नियम और शर्तें जानें। Gita Seva Terms of Use. Available on Gita Seva web & mobile app.",
    ogTitle: "उपयोग की शर्तें | Terms of Use | Gita Seva",
    ogDescription:
      "गीता सेवा की उपयोग की शर्तें — वेबसाइट और ऐप का उपयोग करने से पहले नियम जानें। Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/termsofuse",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/termsofuse" },
      { hrefLang: "en", href: "https://gitaseva.org/termsofuse" },
      { hrefLang: "x-default", href: "https://gitaseva.org/termsofuse" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "उपयोग की शर्तें | Terms of Use | Gita Seva",
      url: "https://gitaseva.org/termsofuse",
      isPartOf: {
        "@type": "WebSite",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
      description:
        "गीता सेवा वेबसाइट और ऐप के उपयोग की शर्तें पढ़ें। सेवा का उपयोग करने से पहले नियम और शर्तें जानें। Gita Seva Terms of Use. Available on Gita Seva web & mobile app.",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
    },
  },
  "/faq": {
    title: "सामान्य प्रश्न | FAQ | Gita Seva",
    description:
      "गीता सेवा से जुड़े अक्सर पूछे जाने वाले प्रश्न और उत्तर। पुस्तकें, पत्रिकाएँ, ऑडियो, प्रवचन और ऐप संबंधी जानकारी। Gita Seva FAQ. Available on Gita Seva web & mobile app.",
    ogTitle: "सामान्य प्रश्न | FAQ | Gita Seva",
    ogDescription:
      "गीता सेवा FAQ — पुस्तकें, पत्रिकाएँ, ऑडियो, प्रवचन और ऐप संबंधी सामान्य प्रश्न। Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/faq",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/faq" },
      { hrefLang: "en", href: "https://gitaseva.org/faq" },
      { hrefLang: "x-default", href: "https://gitaseva.org/faq" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      name: "सामान्य प्रश्न | FAQ | Gita Seva",
      url: "https://gitaseva.org/faq",
      isPartOf: {
        "@type": "WebSite",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
      description:
        "गीता सेवा से जुड़े अक्सर पूछे जाने वाले प्रश्न और उत्तर। पुस्तकें, पत्रिकाएँ, ऑडियो, प्रवचन और ऐप संबंधी जानकारी। Gita Seva FAQ. Available on Gita Seva web & mobile app.",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
    },
  },
  "/promotion": {
    title: "प्रचार सामग्री | Promotion | Gita Seva",
    description:
      "गीता सेवा की प्रचार सामग्री, पैम्फलेट और शेयर करने योग्य संदेश। Gita Seva Promotion. Available on Gita Seva web & mobile app.",
    ogTitle: "प्रचार सामग्री | Promotion | Gita Seva",
    ogDescription:
      "गीता सेवा की प्रचार सामग्री और पैम्फलेट — संदेश शेयर करें। Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/promotion",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/promotion" },
      { hrefLang: "en", href: "https://gitaseva.org/promotion" },
      { hrefLang: "x-default", href: "https://gitaseva.org/promotion" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "प्रचार सामग्री | Promotion | Gita Seva",
      url: "https://gitaseva.org/promotion",
      isPartOf: {
        "@type": "WebSite",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
      description:
        "गीता सेवा की प्रचार सामग्री, पैम्फलेट और शेयर करने योग्य संदेश। Gita Seva Promotion. Available on Gita Seva web & mobile app.",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
    },
  },
  "/books": {
    title: "Read Hindu Religious Books Online | GitaSeva",
    description:
      "Bhagavad Gita, Ramayan, Mahabharat, Puran, Stotra, Aarti एवं हिन्दू spiritual books हिन्दी, Sanskrit, English और अन्य भाषाओं में online पढ़ें। Available on GitaSeva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/books",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/books" },
      { hrefLang: "en", href: "https://gitaseva.org/books" },
      { hrefLang: "x-default", href: "https://gitaseva.org/books" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "Books",
      url: "https://gitaseva.org/books",
      isPartOf: {
        "@type": "WebSite",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
      description:
        "Bhagavad Gita, Ramayan, Mahabharat, Puran, Stotra, Aarti एवं हिन्दू spiritual books हिन्दी, Sanskrit, English और अन्य भाषाओं में online पढ़ें। Available on GitaSeva web & mobile app.",
    },
  },
  "/geetgovind": {
    title: "Geet Govind Magazine | गीता-गोविंद आध्यात्मिक पत्रिका",
    description:
      "Read Geet Govind (गीता-गोविंद) spiritual magazine online with Krishna and Shiva Bhakti articles, devotional teachings, and Sanatan Dharma content. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/geetgovind",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/geetgovind" },
      { hrefLang: "en", href: "https://gitaseva.org/geetgovind" },
      { hrefLang: "x-default", href: "https://gitaseva.org/geetgovind" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/kalyan": {
    title: "Kalyan Magazine | कल्याण आध्यात्मिक पत्रिका - Gita Seva",
    description:
      "Read Kalyan (कल्याण) spiritual magazine online with Bhagavad Gita, Ramayan, Bhakti, Yoga, Dharma, and Sanatan philosophy articles. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/kalyan",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/kalyan" },
      { hrefLang: "en", href: "https://gitaseva.org/kalyan" },
      { hrefLang: "x-default", href: "https://gitaseva.org/kalyan" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/kalyanakalpataru": {
    title: "Kalyana Kalpataru Magazine | Spiritual & Vedanta Articles",
    description:
      "Read Kalyana Kalpataru spiritual magazine online with Vedanta teachings, Krishna Bhakti, Yoga, Dharma, and Sanatan philosophy articles. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/kalyanakalpataru",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/kalyanakalpataru" },
      { hrefLang: "en", href: "https://gitaseva.org/kalyanakalpataru" },
      { hrefLang: "x-default", href: "https://gitaseva.org/kalyanakalpataru" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/vivekvani": {
    title: "Vivek Vani Magazine | विवेक-वाणी आध्यात्मिक पत्रिका",
    description:
      "Read Vivek Vani (विवेक-वाणी) spiritual magazine online with Bhakti, Dharma, Vedanta, and Sanatan philosophy articles in Bangla. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/vivekvani",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/vivekvani" },
      { hrefLang: "en", href: "https://gitaseva.org/vivekvani" },
      { hrefLang: "x-default", href: "https://gitaseva.org/vivekvani" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/audios": {
    title: "Hindu Devotional Audios & Bhajans Online | Gita Seva",
    description:
      "Listen to Bhagavad Gita Path, Bhajan, Kirtan, Hanuman Chalisa, Ramayan, Krishna Bhakti, and Hindu devotional audios online. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/audios",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/audios" },
      { hrefLang: "en", href: "https://gitaseva.org/audios" },
      { hrefLang: "x-default", href: "https://gitaseva.org/audios" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/pravachans": {
    title: "Spiritual Pravachans Online | Hindu Dharma & Bhakti Discourses",
    description:
      "Listen to spiritual Pravachans, Bhagavad Gita teachings, and Bhakti discourses by Swami Ramsukhdas Ji Maharaj, Hanuman Prasad Poddar Ji, and other saints. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/pravachans",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/pravachans" },
      { hrefLang: "en", href: "https://gitaseva.org/pravachans" },
      { hrefLang: "x-default", href: "https://gitaseva.org/pravachans" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/DailySatsang": {
    title: "Daily Satsang, Gita Path & Pravachan Online | Gita Seva",
    description:
      "Listen to Daily Satsang, Bhagavad Gita Path, Nitya Prarthana, spiritual Pravachans, and Bhakti teachings by Swami Ramsukhdas Ji Maharaj and other saints. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/DailySatsang",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/DailySatsang" },
      { hrefLang: "en", href: "https://gitaseva.org/DailySatsang" },
      { hrefLang: "x-default", href: "https://gitaseva.org/DailySatsang" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/videos": {
    title: "Hindu Spiritual Videos, Katha & Pravachan Online | Gita Seva",
    description:
      "Watch Shrimad Bhagavat Mahapuran Katha, Ramayan, Mahabharat, Devi Bhagavat, Pravachan, and Hindu spiritual videos online. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/videos",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/videos" },
      { hrefLang: "en", href: "https://gitaseva.org/videos" },
      { hrefLang: "x-default", href: "https://gitaseva.org/videos" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/divinequotes": {
    title: "Daily Hindu Spiritual Quotes, Puran & Upnishad Thoughts| Gita Seva",
    description:
      "Read daily Amrit Vachan, spiritual quotes, Bhagavad Gita thoughts, Vedic wisdom, Guru teachings, Upanishad insights, and Sanatan Dharma messages online. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/divinequotes",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/divinequotes" },
      { hrefLang: "en", href: "https://gitaseva.org/divinequotes" },
      { hrefLang: "x-default", href: "https://gitaseva.org/divinequotes" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/articles": {
    title: "Spiritual Articles, Gita Gyan & Sanatan Wisdom | Gita Seva",
    description:
      "Read spiritual articles on Bhagavad Gita, Bhakti, Dharma, Meditation, Ram Naam Jap, Vedic wisdom, and Sanatan philosophy. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/articles",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/articles" },
      { hrefLang: "en", href: "https://gitaseva.org/articles" },
      { hrefLang: "x-default", href: "https://gitaseva.org/articles" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/magazines": {
    title: "Read Hindu Spiritual Magazines Online | Kalyan & Geet Govind | Gita Seva",
    description:
      "Read Kalyan, Kalyan Kalpataru, Geet Govind, and Vivek Vani spiritual magazines online. Access monthly and special issues on Sanatan Dharma. Available on Gita Seva.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/magazines",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/magazines" },
      { hrefLang: "en", href: "https://gitaseva.org/magazines" },
      { hrefLang: "x-default", href: "https://gitaseva.org/magazines" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/magazines/geetgovind": {
    title: "Geet Govind Magazine | गीता-गोविंद आध्यात्मिक पत्रिका",
    description:
      "Read Geet Govind (गीता-गोविंद) spiritual magazine online with Krishna and Shiva Bhakti articles, devotional teachings, and Sanatan Dharma content. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/magazines/geetgovind",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/magazines/geetgovind" },
      { hrefLang: "en", href: "https://gitaseva.org/magazines/geetgovind" },
      { hrefLang: "x-default", href: "https://gitaseva.org/magazines/geetgovind" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/magazines/kalyan": {
    title: "Kalyan Magazine | कल्याण आध्यात्मिक पत्रिका - Gita Seva",
    description:
      "Read Kalyan (कल्याण) spiritual magazine online with Bhagavad Gita, Ramayan, Bhakti, Yoga, Dharma, and Sanatan philosophy articles. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/magazines/kalyan",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/magazines/kalyan" },
      { hrefLang: "en", href: "https://gitaseva.org/magazines/kalyan" },
      { hrefLang: "x-default", href: "https://gitaseva.org/magazines/kalyan" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/magazines/kalyanakalpataru": {
    title: "Kalyana Kalpataru Magazine | Spiritual & Vedanta Articles",
    description:
      "Read Kalyana Kalpataru spiritual magazine online with Vedanta teachings, Krishna Bhakti, Yoga, Dharma, and Sanatan philosophy articles. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/magazines/kalyanakalpataru",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/magazines/kalyanakalpataru" },
      { hrefLang: "en", href: "https://gitaseva.org/magazines/kalyanakalpataru" },
      { hrefLang: "x-default", href: "https://gitaseva.org/magazines/kalyanakalpataru" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/magazines/vivekvani": {
    title: "Vivek Vani Magazine | विवेक-वाणी आध्यात्मिक पत्रिका",
    description:
      "Read Vivek Vani (विवेक-वाणी) spiritual magazine online with Bhakti, Dharma, Vedanta, and Sanatan philosophy articles in Bangla. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/magazines/vivekvani",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/magazines/vivekvani" },
      { hrefLang: "en", href: "https://gitaseva.org/magazines/vivekvani" },
      { hrefLang: "x-default", href: "https://gitaseva.org/magazines/vivekvani" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/Audio": {
    title: "Hindu Devotional Audios & Bhajans Online | Gita Seva",
    description:
      "Listen to Bhagavad Gita Path, Bhajan, Kirtan, Hanuman Chalisa, Ramayan, Krishna Bhakti, and Hindu devotional audios online. Available on Gita Seva web & mobile app.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/Audio",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/Audio" },
      { hrefLang: "en", href: "https://gitaseva.org/Audio" },
      { hrefLang: "x-default", href: "https://gitaseva.org/Audio" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
  },
  "/author/honorable-shri-jayadayal-ji-goyandka": {
    title: "Shri Jayadayal Ji Goyandka | Author | GitaSeva",
    description:
      "Books, Audios, Pravachans & Articles by Shri Jayadayal Ji Goyandka on GitaSeva. Read and listen to spiritual works by this revered author.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/author/honorable-shri-jayadayal-ji-goyandka",
    ogType: "profile",
    robots: "index, follow",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    siteName: DEFAULT_SEO_TITLE,
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/author/honorable-shri-jayadayal-ji-goyandka" },
      { hrefLang: "en", href: "https://gitaseva.org/author/honorable-shri-jayadayal-ji-goyandka" },
      { hrefLang: "x-default", href: "https://gitaseva.org/author/honorable-shri-jayadayal-ji-goyandka" },
    ],
  },
  "/author/honorable-shri-hanuman-prasad-ji-poddar": {
    title: "Shri Hanuman Prasad Ji Poddar | Author | GitaSeva",
    description:
      "Books, Audios, Pravachans & Articles by Shri Hanuman Prasad Ji Poddar on GitaSeva. Read and listen to spiritual works by this revered author.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/author/honorable-shri-hanuman-prasad-ji-poddar",
    ogType: "profile",
    robots: "index, follow",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    siteName: DEFAULT_SEO_TITLE,
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/author/honorable-shri-hanuman-prasad-ji-poddar" },
      { hrefLang: "en", href: "https://gitaseva.org/author/honorable-shri-hanuman-prasad-ji-poddar" },
      { hrefLang: "x-default", href: "https://gitaseva.org/author/honorable-shri-hanuman-prasad-ji-poddar" },
    ],
  },
  "/author/honorable-swami-ramsukhdas-ji-maharaj": {
    title: "Swami Ramsukhdas Ji Maharaj | Author | GitaSeva",
    description:
      "Books, Audios, Pravachans & Articles by Swami Ramsukhdas Ji Maharaj on GitaSeva. Read and listen to spiritual works by this revered author.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/author/honorable-swami-ramsukhdas-ji-maharaj",
    ogType: "profile",
    robots: "index, follow",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    siteName: DEFAULT_SEO_TITLE,
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/author/honorable-swami-ramsukhdas-ji-maharaj" },
      { hrefLang: "en", href: "https://gitaseva.org/author/honorable-swami-ramsukhdas-ji-maharaj" },
      { hrefLang: "x-default", href: "https://gitaseva.org/author/honorable-swami-ramsukhdas-ji-maharaj" },
    ],
  },
  "/404.html": {
    title: `404 - Page Not Found | ${DEFAULT_SEO_TITLE}`,
    description: "The page you are looking for could not be found on Gita Seva.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/404.html",
    ogType: "website",
    robots: "noindex, follow",
  },
};
